const clientRequests = {
  // Page titles
  pageTitle: 'Submit Your Property Request',
  pageSubtitle: 'Describe what you are looking for and verified brokers will contact you',

  // Stepper steps
  steps: {
    propertyDetails: 'Property Details',
    location: 'Location',
    budget: 'Budget',
    preferences: 'Preferences',
    contact: 'Contact Info',
    // Steps of the "Post a request" wizard (pages/client-requests/CreateClientRequest.tsx).
    type: 'Request type',
    details: 'Details',
  },

  // Property type section
  propertyType: {
    title: 'Property Type',
    subtitle: 'Select the type of property you are looking for',
    apartment: 'Apartment',
    villa: 'Villa',
    land: 'Land',
    building: 'Building',
    office: 'Office',
    shop: 'Shop',
    warehouse: 'Warehouse',
    farm: 'Farm',
    duplex: 'Duplex',
    penthouse: 'Penthouse',
    chalet: 'Chalet',
    compound: 'Compound',
  },

  // Transaction type
  transactionType: {
    title: 'Transaction Type',
    buy: 'Buy',
    rent: 'Rent',
  },

  // Location section
  location: {
    title: 'Desired Location',
    subtitle: 'Select your preferred city and district',
    city: 'City',
    cityPlaceholder: 'Select city',
    district: 'District',
    districtPlaceholder: 'Select district',
    districtOptional: 'District (Optional)',
    anyDistrict: 'Any district',
  },

  // Budget section
  budget: {
    title: 'Budget',
    subtitle: 'Set your budget range',
    min: 'Minimum',
    max: 'Maximum',
    minPlaceholder: 'From',
    maxPlaceholder: 'To',
    currency: 'SAR',
    flexible: 'Flexible budget',
    flexibleDescription: 'I can consider offers slightly above my budget',
  },

  // Rental duration
  rentalDuration: {
    title: 'Rental Duration',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    semiAnnual: 'Semi-Annual',
    annual: 'Annual',
  },

  // Preferences section
  preferences: {
    title: 'Preferences',
    subtitle: 'Tell us about your additional requirements',
    rooms: 'Bedrooms',
    roomsPlaceholder: 'Select',
    bathrooms: 'Bathrooms',
    bathroomsPlaceholder: 'Select',
    area: 'Area (sqm)',
    areaMin: 'Min',
    areaMax: 'Max',
    moveInDate: 'Move-in Date',
    moveInDatePlaceholder: 'Select date',
    moveInFlexible: 'Date is flexible',
    notes: 'Additional Notes',
    notesPlaceholder: 'Write any additional requirements or preferences...',
  },

  // Features/Amenities
  amenities: {
    title: 'Required Features',
    parking: 'Parking',
    pool: 'Pool',
    garden: 'Garden',
    elevator: 'Elevator',
    security: 'Security',
    gym: 'Gym',
    furnished: 'Furnished',
    maidRoom: 'Maid Room',
    driverRoom: 'Driver Room',
    ac: 'Central AC',
    balcony: 'Balcony',
    kitchen: 'Kitchen',
  },

  // Contact section
  contact: {
    title: 'Contact Information',
    subtitle: 'How can brokers reach you?',
    name: 'Name',
    namePlaceholder: 'Your full name',
    phone: 'Phone Number',
    phonePlaceholder: '05xxxxxxxx',
    email: 'Email',
    emailPlaceholder: 'example@email.com',
    emailOptional: 'Email (Optional)',
    preferredContact: 'Preferred Contact Method',
    contactCall: 'Phone Call',
    contactWhatsapp: 'WhatsApp',
    contactBoth: 'Both',
    preferredTime: 'Preferred Contact Time',
    anytime: 'Anytime',
    morning: 'Morning (8AM - 12PM)',
    afternoon: 'Afternoon (12PM - 5PM)',
    evening: 'Evening (5PM - 9PM)',
  },

  // Privacy options
  privacy: {
    title: 'Privacy Options',
    private: 'Private Request',
    privateDescription: 'Your request will only be visible to verified brokers',
    public: 'Public Request',
    publicDescription: 'Your request will be visible in the requests marketplace',
  },

  // Actions
  actions: {
    next: 'Next',
    back: 'Back',
    submit: 'Submit Request',
    submitting: 'Submitting...',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    viewOffers: 'View Offers',
  },

  // Success page
  success: {
    title: 'Request Submitted Successfully!',
    subtitle: 'Verified brokers will contact you soon',
    requestNumber: 'Request Number',
    whatNext: 'What happens next?',
    step1: 'Verified brokers will review your request',
    step2: 'You will receive offers from suitable brokers',
    step3: 'Choose the best offer and contact the broker',
    viewMyRequests: 'View My Requests',
    submitAnother: 'Submit Another Request',
    backToHome: 'Back to Home',
  },

  // My requests page
  myRequests: {
    title: 'My Requests',
    subtitle: 'Track your property requests and broker offers',
    noRequests: 'No Requests',
    noRequestsDesc: 'You have not submitted any property requests yet',
    createFirst: 'Submit Your First Request',
    filter: {
      all: 'All',
      active: 'Active',
      closed: 'Closed',
      expired: 'Expired',
    },
    offersCount: 'offer',
    offersCountPlural: 'offers',
    newOffers: 'new offers',
    viewDetails: 'View Details',
  },

  // Request status
  status: {
    active: 'Active',
    closed: 'Closed',
    expired: 'Expired',
    pending: 'Pending Review',
  },

  // Broker side - Request listing
  broker: {
    title: 'Requests Marketplace',
    subtitle: 'Browse client requests and submit your offers',
    filters: {
      title: 'Filter Results',
      propertyType: 'Property Type',
      city: 'City',
      budgetRange: 'Budget Range',
      transactionType: 'Transaction Type',
      clearAll: 'Clear All',
    },
    sort: {
      newest: 'Newest',
      budgetHigh: 'Budget: Highest',
      budgetLow: 'Budget: Lowest',
      urgent: 'Most Urgent',
    },
    noResults: 'No matching requests',
    noResultsDesc: 'Try changing your search criteria',
    loadMore: 'Load More',
    viewRequest: 'View Request',
    submitOffer: 'Submit Offer',
    contactClient: 'Contact Client',
    alreadyResponded: 'Offer Submitted',
    leadPrice: 'Lead Price',
    purchaseLead: 'Purchase Contact Info',
    leadPurchased: 'Lead Purchased',
    // Called without keys before, so English showed the Arabic defaults.
    loadError: 'Could not load the requests. Please try again.',
    signIn: 'Sign in as an approved broker to browse requests.',
    agentsOnly: 'Available to approved brokers only',
    agentsOnlyDesc: 'Your account must be an approved broker account to browse client requests.',
  },

  // Submit offer modal
  offer: {
    title: 'Submit Your Offer',
    subtitle: 'Describe the property you want to offer to the client',
    propertyTitle: 'Property Title',
    propertyTitlePlaceholder: 'Example: Luxury villa in Al-Narjis',
    propertyDescription: 'Property Description',
    propertyDescriptionPlaceholder: 'Write a detailed description of the property...',
    price: 'Offered Price',
    pricePlaceholder: 'Enter price',
    location: 'Property Location',
    locationPlaceholder: 'District and street',
    attachProperty: 'Or select from your listings',
    selectProperty: 'Select Property',
    message: 'Message to Client',
    messagePlaceholder: 'Write a short message to the client...',
    submit: 'Submit Offer',
    cancel: 'Cancel',
    success: 'Your offer was submitted successfully',
    error: 'An error occurred while submitting your offer',
  },

  // Validation messages
  validation: {
    propertyTypeRequired: 'Please select a property type',
    transactionTypeRequired: 'Please select a transaction type',
    cityRequired: 'Please select a city',
    budgetRequired: 'Please specify your budget',
    budgetMinMax: 'Maximum must be greater than minimum',
    nameRequired: 'Please enter your name',
    phoneRequired: 'Please enter your phone number',
    phoneInvalid: 'Invalid phone number',
    emailInvalid: 'Invalid email address',
  },

  // General
  general: {
    sar: 'SAR',
    sqm: 'sqm',
    room: 'room',
    rooms: 'rooms',
    bathroom: 'bathroom',
    bathrooms: 'bathrooms',
    any: 'Any',
    from: 'From',
    to: 'To',
    or: 'or',
    required: 'Required',
    optional: 'Optional',
  },

  // Counts after a number on the request cards (BrokerRequestsList, MyRequests).
  counts: {
    bedrooms_one: '{{count}} bedroom',
    bedrooms_other: '{{count}} bedrooms',
    bathrooms_one: '{{count}} bathroom',
    bathrooms_other: '{{count}} bathrooms',
    // Results count above the request list on BrokerRequestsList.
    results_one: '{{count}} result',
    results_other: '{{count}} results',
  },

  // Requests marketplace (BrokerRequestsList) strings that had no keys, so the
  // English page showed their Arabic defaults.
  in: 'in',
  loadingText: 'Loading...',

  // "Post a request" wizard (pages/client-requests/CreateClientRequest.tsx). Without
  // these keys the English page fell back to the Arabic defaults.
  createRequestTitle: 'Post your request',
  createRequestSubtitle: 'Tell us what you are looking for and approved brokers will contact you',
  stepperLabel: 'Request steps',
  requestTypeLabel: 'What are you looking for?',
  rent: 'Rent',
  buy: 'Buy',
  demandTypeLabel: 'Request type (requests board)',
  propertyTypeLabel: 'Property type',
  cityLabel: 'City',
  selectCity: 'Choose a city',
  districtsLabel: 'Preferred districts',
  districtsPlaceholder: 'Enter districts separated by commas',
  districtsHelp: 'e.g. Al Nakheel, Al Malqa, Al Yasmin',
  budgetLabel: 'Budget (SAR)',
  minBudget: 'Minimum',
  maxBudget: 'Maximum',
  bedroomsLabel: 'Bedrooms',
  bathroomsLabel: 'Bathrooms',
  minAreaLabel: 'Minimum area (m²)',
  minAreaPlaceholder: 'e.g. 150',
  moveInDateLabel: 'Expected move-in date',
  rentalDurationLabel: 'Rental duration',
  selectDuration: 'Choose a duration',
  specialRequirementsLabel: 'Special requirements',
  specialRequirementsPlaceholder: 'e.g. near a school, parking, garden...',
  privateRequestLabel: 'Private request',
  privateRequestDesc: 'Your request is not shown publicly, only to approved brokers',
  nameLabel: 'Name',
  namePlaceholder: 'Enter your name',
  phoneLabel: 'Mobile number',
  phonePlaceholder: '5xxxxxxxx',
  emailLabel: 'Email',
  emailPlaceholder: 'example@email.com',
  preferredContactLabel: 'Preferred contact method',
  previous: 'Previous',
  next: 'Next',
  submitting: 'Submitting...',
  submitRequest: 'Submit request',
  errors: {
    missingContact: 'Please fill in your name, email and mobile number',
    missingType: 'Please choose a property type',
    submit: 'We could not send your request. Please try again.',
  },
};

export default clientRequests;
